// quiz-config.js
// Globale Namespace-Vorbereitung
window.CatQuiz = window.CatQuiz || {};

// --------------------------------------------------
// Konfiguration & Konstanten
// --------------------------------------------------

CatQuiz.config = {
  FOOD_CATALOG: [
    {
      code: "huhn",
      uiKey: "huhn",
      label: "Huhn",
      variantId: 55297083638084,
      packSizeGrams: 100,
      allergenTags: ["huhn"],
      analytics: {
        protein: 10.5,
        fat: 5.0,
        ash: 2.2,
        fiber: 0.3,
        moisture: 79.0,
      },
      isActive: true,
      sortOrder: 10,
    },
    {
      code: "huhn_forelle",
      uiKey: "huhnForelle",
      label: "Huhn & Forelle",
      variantId: 54993384276292,
      packSizeGrams: 100,
      allergenTags: ["huhn", "fisch"],
      analytics: {
        protein: 9.0,
        fat: 6.5,
        ash: 2.5,
        fiber: 0.5,
        moisture: 78.0,
      },
      isActive: true,
      sortOrder: 20,
    }
  ],

  GESUNDHEITSPLAN_VARIANT_ID: 56264612938052, // Fellinorafutter Gesundheitsplan
  GESUNDHEITSPLAN_OWN_FOOD_ID: 56446279418180, //neu
  GESUNDHEITSPLAN_REZEPTE_KOCH_BARF_ID: 56446286954820 , //neu 


  // Fütterungsplan-Variante
  FUTTERPLAN_VARIANT_ID: 55878359122244, // 2 Mahlzeiten / Default
  FUTTERPLAN_3_Mahlzeiten_ID: 56446456561988,
  FUTTERPLAN_4_Mahlzeiten_ID: 56446458593604,
  FUTERPLAN_4_Mahlzeiten_ID: 56446458593604, // Legacy-Alias

  // Nährstoffplan
  NAEHRSTOFFPLAN_ID: 56491498406212,


  // Rezept-Upsells (Single Source of Truth)
  RECIPE_UPSELL_VARIANTS: [
    {
      variantId: 56518129123652,
      fallbackTitle: "Testrezept 1 Huhn",
      ingredients: ["Inhaltsstoffe für Testrezept 1 bitte noch hinterlegen."]
    },
    {
      variantId: 56521476440388,
      fallbackTitle: "Testrezept 2 Wild",
      ingredients: ["Inhaltsstoffe für Testrezept 2 bitte noch hinterlegen."]
    },
    {
      variantId: 56521476571460,
      fallbackTitle: "Testrezept 3 Forelle",
      ingredients: ["Inhaltsstoffe für Testrezept 3 bitte noch hinterlegen."]
    },
    {
      variantId: 56521477849412,
      fallbackTitle: "Testrezept 4 Rind",
      ingredients: ["Inhaltsstoffe für Testrezept 4 bitte noch hinterlegen."]
    }
  ],

  BARF_RECIPE_VARIANTS: [
    {
      variantId: 56595468386628,
      fallbackTitle: "BARF Rezept 1 Huhn",
      ingredients: ["Inhaltsstoffe für BARF Rezept 1 bitte noch hinterlegen."]
    },
    {
      variantId: 565954775944,
      fallbackTitle: "BARF Rezept 2 Forelle",
      ingredients: ["Inhaltsstoffe für BARF Rezept 2 bitte noch hinterlegen."]
    }
  ],


  // Idealgewichte nach Rasse & Geschlecht (kg)
  IDEAL_WEIGHTS: {
    "Abessinier": { female: 3, male: 4 },
    "Burma": { female: 3, male: 4 },
    "Devon Rex": { female: 3, male: 4 },
    "Siam": { female: 3, male: 4 },
    "Somali-Katze": { female: 3, male: 4 },
    "Orientalisch Kurzhaar": { female: 4, male: 5 },
    "Orientalisch Langhaar": { female: 4, male: 5 },
    "Balinese": { female: 4, male: 5 },
    "Tonkanese": { female: 4, male: 5 },
    "Türkisch Angora": { female: 4, male: 5 },
    "Cornish Rex": { female: 3, male: 4 },
    "Singapura": { female: 3, male: 3 },
    "Europäische Hauskatze (Mischling)": { female: 4, male: 5 },
    "Heilige Birma": { female: 4, male: 5 },
    "Perser": { female: 4, male: 5 },
    "British Kurzhaar": { female: 4, male: 5 },
    "British Langhaar": { female: 5, male: 7 },
    "Karthäuser (Chartreux)": { female: 4, male: 5 },
    "Russisch Blau": { female: 4, male: 6 },
    "Scottish Fold": { female: 5, male: 5 },
    "Deutsch Langhaar": { female: 5, male: 6 },
    "Exotic Shorthair": { female: 3, male: 4 },
    "Ägyptisch Mau": { female: 3, male: 4 },
    "Bengal": { female: 4, male: 6 },
    "Burmilla": { female: 4, male: 6 },
    "Selkirk Rex": { female: 6, male: 7 },
    "American Bobtail": { female: 6, male: 6 },
    "Koratkatze": { female: 6, male: 6 },
    "Sibirische Katze": { female: 6, male: 8 },
    "Ragdoll": { female: 6, male: 9 },
    "Maine Coon": { female: 6, male: 9 },
    "Norwegische Waldkatze": { female: 6, male: 9 }
  },

  // Selling-Plan-IDs (Abo)
  SELLING_PLANS: {
    30: 693028127044
  },

  QUIZ_ID:      "Quiz",
  QUIZ_VERSION: "1.0",

  // wird unten beim Start gesetzt
  QUIZ_TAG: "",

  // wird ebenfalls beim Start gesetzt
  QUIZ_SESSION_ID: "",

  ANALYTICS_ENDPOINT: ""
};

// Session-ID & Tag direkt beim Laden generieren
(function initQuizConfig() {
  const cfg = CatQuiz.config;

  cfg.QUIZ_TAG = `${cfg.QUIZ_ID} v${cfg.QUIZ_VERSION}`;

  cfg.QUIZ_SESSION_ID = (window.crypto && window.crypto.randomUUID)
    ? window.crypto.randomUUID()
    : ("catquiz-" + Date.now() + "-" + Math.random().toString(16).slice(2));

  // Backward-compatible VARIANTS aliases derived from the generic FOOD_CATALOG.
  // Source of truth remains FOOD_CATALOG; these aliases only keep older UI/cart code alive.
  cfg.VARIANTS = (cfg.VARIANTS && typeof cfg.VARIANTS === "object") ? cfg.VARIANTS : {};
  (Array.isArray(cfg.FOOD_CATALOG) ? cfg.FOOD_CATALOG : []).forEach((food) => {
    const variantId = Number(food?.variantId || 0);
    const packSize = Number(food?.packSizeGrams || 100) || 100;
    if (!variantId) return;

    const uiKey = String(food?.uiKey || "").trim();
    const codeKey = String(food?.code || "").replace(/[^a-z0-9]+/gi, "").trim();

    if (uiKey) cfg.VARIANTS[`${uiKey}${packSize}g`] = variantId;
    if (codeKey) cfg.VARIANTS[`${codeKey}${packSize}g`] = variantId;
  });
})();


// --------------------------------------------------
// Labels & Listen
// --------------------------------------------------

CatQuiz.labels = {
  // Katzenrassen-Liste für Autocomplete
  CAT_BREEDS: [
    "Abessinier",
    "Burma",
    "Devon Rex",
    "Siam",
    "Somali-Katze",
    "Europäische Hauskatze (Mischling)",
    "Heilige Birma",
    "Perser",
    "British Kurzhaar",
    "Karthäuser (Chartreux)",
    "Sibirische Katze",
    "Maine Coon",
    "Norwegische Waldkatze",
    "Bengal",
    "Orientalisch Kurzhaar",
    "Russisch Blau",
    "Scottish Fold",
    "Selkirk Rex",
    "American Bobtail",
    "Balinese",
    "British Langhaar",
    "Deutsch Langhaar",
    "Orientalisch Langhaar",
    "Ragdoll",
    "Türkisch Angora",
    "Tonkanese",
    "Singapura",
    "Koratkatze",
    "Exotic Shorthair",
    "Cornish Rex",
    "Burmilla",
    "Ägyptisch Mau"
  ],

  // Anzeigenamen für Allergie-Values
  // Hinweis: "rind" bleibt als Value für die Checkbox bestehen,
  // auch wenn das Produkt inzwischen Huhn & Forelle ist.
  ALLERGY_LABELS: {
    huhn:      "Huhn",
    rind:      "Rind",
    fisch:     "Fisch",
    pute:      "Pute",
    wild:      "Wild",
    kaninchen: "Kaninchen",
    lamm:      "Lamm",
    laktose:   "Laktose",
    getreide:  "Getreide",
    ente:      "Ente"
  },

  // Anzeigenamen für Gesundheitsfokus-Values
  HEALTH_LABELS: {
    haut_fellpflege: "Haut- & Fellpflege",
    immunsystem:     "Immunsystem",
    knochen:         "Knochen",
    verdauung:       "Verdauung",
    mundhygiene:     "Mundhygiene",
    koerpergewicht:  "Körpergewicht",
    auge:            "Auge",
    herz_kreislauf:  "Herz- & Kreislaufsystem",
    fitness:         "Fitness"
  },

  // Anzeigenamen für Tierschutz-Partner
  SOCIAL_LABELS: {
    tierheim:       "Tierheime in Deutschland",
    wildkatzen:     "Wildkatzen-Projekt Deutschland",
    strassenkatzen: "Straßenkatzen in Europa",
    custom:         "deine Herzens-Organisation"
  }
};

// --------------------------------------------------
// Analytics-Helfer
// --------------------------------------------------

CatQuiz.config.sendEvent = function(eventName, payload = {}) {
  const {
    QUIZ_ID,
    QUIZ_VERSION,
    QUIZ_SESSION_ID,
    ANALYTICS_ENDPOINT
  } = CatQuiz.config;

  const event = {
    event_name:      eventName,
    timestamp:       new Date().toISOString(),
    quiz_id:         QUIZ_ID,
    quiz_version:    QUIZ_VERSION,
    quiz_session_id: QUIZ_SESSION_ID,
    ...payload
  };

  if (console && console.debug) {
    console.debug("[Quiz Analytics]", event);
  }

  if (!ANALYTICS_ENDPOINT) return;

  try {
    fetch(ANALYTICS_ENDPOINT, {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify(event),
      keepalive: true
    }).catch(() => {});
  } catch (err) {
    // Analytics-Fehler ignorieren
  }
};

// --------------------------------------------------
// FAQ (Premium Accordion) – Single Source of Truth
// --------------------------------------------------
CatQuiz.config.FAQ_ITEMS = [
  {
    q: "Wie viel kostet Fellinora?",
    a:
      "Das individuelle Ernährungskonzept kostet weniger als ein typisches Essen im Restaurant.\n\n" +
      "Dafür erhältst du eine umfassende Ernährungsberatung, einen Gesundheitsplan sowie einen Futterplan mit genau abgestimmten Futtermengen und Fütterungszeiten.\n\n" +
      "Das Besondere ist, dass die Ernährung regelmäßig an die aktuellen Bedürfnisse deiner Katze angepasst wird."
  },
  {
    q: "Was erhalte ich alles im Ernährungskonzept?",
    a:
      "Das Ernährungskonzept besteht aus vier Bausteinen.\n\n" +
      "1. Futterbewertung: Wir prüfen dein aktuelles Futter und bewerten, ob es den Ernährungsbedürfnissen deiner Katze entspricht.\n\n" +
      "2. Gesundheitsplan: Hier berechnen wir den individuellen Nährstoffbedarf deiner Katze, zum Beispiel den Kalorien-, Eiweiß- und Flüssigkeitsbedarf.\n\n" +
      "3. Futterplan: Wir erstellen einen persönlichen Futterplan mit passenden Futtermengen und Fütterungszeiten. Diesen erhältst du als übersichtlichen Plan für vier Wochen bequem nach Hause geschickt.\n\n" +
      "4. Ernährungsberatung: Du erhältst konkrete Ernährungsempfehlungen für deine Katze. Zusätzlich steht dir unser digitaler Ernährungsberater jederzeit für Fragen zur Verfügung."
  },
  {
    q: "Was ist alles im Futterplan enthalten?",
    a:
      "Der Futterplan von Fellinora wird anhand dem persönlichen Kalorienbedarf deiner Katze berechnet.\n\n" +
      "Anhand des individuellen Bedarfs berechnen wir die genauen Futtermengen, die zu deiner Katze passen.\n\n" +
      "Außerdem erhältst du noch optimierte Futterzeiten für eine artgerechte Ernährung.\n\n" +
      "Den Plan kannst du bei jeder Fütterung abharken und wir schicken ihn dir für 4 Wochen ausgedruckt nach Hause."
  },
  {
    q: "Wie funktioniert die Ernährungsberatung?",
    a:
      "Unsere Ernährungsexperten erstellen auf Grundlage der Angaben zu deiner Katze einen Gesundheitsplan mit konkreten Ernährungsempfehlungen, die sich zum Beispiel am Alter und an den individuellen Bedürfnissen deiner Katze orientieren.\n\n" +
      "Zusätzlich steht dir rund um die Uhr unser digitaler Ernährungsberater zur Verfügung.\n\n" +
      "Dr. Felli beantwortet deine Fragen zur Katzenernährung jederzeit und basiert dabei auf aktuellem wissenschaftlichem Wissen."
  },
  {
    q: "Warum ein Abo?",
    a:
      "Durch das Abo können wir sicherstellen, dass das Ernährungskonzept immer zu den aktuellen Bedürfnissen deiner Katze passt.\n\n" +
      "Eine langfristig abgestimmte Ernährung kann dabei helfen, die Versorgung deiner Katze dauerhaft zu unterstützen.\n\n" +
      "Du kannst dein Abo selbstverständlich jederzeit anpassen, pausieren oder kündigen.\n\n" +
      "Du musst dich um nichts kümmern und erhältst regelmäßig deinen aktuellen Futterplan für deine Katze."
  },
  {
    q: "Wie wird der Gesundheitsplan erstellt?",
    a:
      "Der Gesundheitsplan wird von unseren Fellinoraexperten auf Basis deiner Angaben erstellt.\n\n" +
      "Anhand deiner Antworten berechnen wir die individuellen Bedürfnisse deiner Katze, zum Beispiel den täglichen Kalorienbedarf, den Nährstoffbedarf und den Wasserbedarf.\n\n" +
      "Auf dieser Grundlage erhältst du konkrete, auf deine Katze abgestimmte Ernährungsempfehlungen.\n\n" +
      "So kannst du sie optimal versorgen und hast bei jeder Fütterung ein gutes Gewissen."
  },
  {
    q: "Ist Fellinora sicher für meine Katze?",
    a:
      "Ja. Unser Konzept wurde in Zusammenarbeit mit Tierärztinnen und Tierärzten entwickelt und basiert auf über 200 wissenschaftlichen Veröffentlichungen.\n\n" +
      "Das Konzept wurde in Deutschland entwickelt und wurde von Katzeneltern für Katzeneltern erstellt."
  },
  {
    q: "Kann ich mein Abo jederzeit kündigen?",
    a:
      "Ja, natürlich. In deinem Kundenprofil kannst du dein Abo jederzeit kündigen.\n\n" +
      "Du hast volle Kontrolle und maximale Transparenz: Du kannst Änderungen vornehmen, das Abo pausieren oder beenden, wann immer du möchtest.\n\n" +
      "Bei Fragen steht dir unser Team jederzeit gerne zur Seite.\n\n" +
      "Denn genau wie bei uns Menschen ist es auch bei Katzen wichtig, die Ernährung regelmäßig an ihre Bedürfnisse anzupassen. Nur so kann die Gesundheit langfristig unterstützt und verbessert werden."
  },
  {
    q: "Wann wird eine Zahlung fällig?",
    a:
      "Kundenfreundlichkeit hat für uns höchste Priorität. Deshalb erhältst du vor jeder Lieferung eine Erinnerungs-E-Mail.\n\n" +
      "So hast du jederzeit die Möglichkeit, eine Lieferung zu pausieren oder zu stornieren.\n\n" +
      "Du kannst außerdem jederzeit Änderungen vornehmen und Futter hinzufügen oder entfernen.\n\n" +
      "Die Zahlung wird erst nach dem Versand deiner Bestellung an dich abgebucht."
  },
  {
    q: "Wird der Futterplan laufend an die Bedürfnisse angepasst?",
    a:
      "Ja, der Futter- und Gesundheitsplan wird regelmäßig an die Bedürfnisse deiner Katze angepasst.\n\n" +
      "Genau wie bei uns Menschen verändern sich diese im Laufe des Lebens, zum Beispiel durch Alter, Aktivitätslevel oder gesundheitliche Entwicklungen.\n\n" +
      "Je nach Ernährungsbedarf deiner Katze senden wir dir in bestimmten Abständen einen kurzen Fragebogen.\n\n" +
      "Anhand deiner Antworten prüfen wir, ob die aktuellen Futtermengen noch passend sind. Falls Anpassungen sinnvoll sind, aktualisieren wir den Futterplan automatisch.\n\n" +
      "So musst du dich um nichts kümmern und kannst sicher sein, dass deine Katze weiterhin gut versorgt wird."
  },
  {
    q: "Ist Fellinora auch für ältere Katzen geeignet?",
    a:
      "Ja, Fellinora ist auch für ältere Katzen bestens geeignet.\n\n" +
      "Senior-Katzen haben häufig eine empfindlichere Verdauung und können Futter nicht mehr so gut verwerten.\n\n" +
      "Deshalb benötigen sie oft kleinere Portionen mit einem höheren Nährstoffgehalt.\n\n" +
      "Unser Futter enthält hochwertige, leicht verdauliche Proteine und sorgfältig ausgewählte Nährstoffe, die speziell auf diese Bedürfnisse abgestimmt sind und ältere Katzen optimal unterstützen."
  },
  {
    q: "Verbessert Fellinora die Gesundheit meiner Katze?",
    a:
      "Fellinora kann das Wohlbefinden und die Gesundheit deiner Katze durch eine bedarfsgerechte Ernährung unterstützen.\n\n" +
      "Die passend berechneten Futtermengen helfen dabei, ein gesundes Körpergewicht zu fördern.\n\n" +
      "Zusätzlich geben dir die fundierten Ernährungsempfehlungen Orientierung, wie du deine Katze langfristig ausgewogen und artgerecht ernähren kannst.\n\n" +
      "So kann eine gute Versorgung dazu beitragen, ernährungsbedingte Probleme frühzeitig zu vermeiden."
  },
  {
    q: "Was passiert mit meiner Spende an ein Tierschutzprojekt?",
    a:
      "Uns ist nicht nur die Gesundheit deiner Katze zu Hause wichtig, sondern auch das Wohl von Katzen in Not.\n\n" +
      "Viele Tierschutzprojekte arbeiten am Limit und verfügen oft nicht über ausreichende finanzielle Mittel.\n\n" +
      "Mit deiner Bestellung unterstützt du ausgewählte Tierschutzprojekte und hilfst dabei, Katzen ein besseres Leben zu ermöglichen.\n\n" +
      "Deinen aktuellen Spendenbetrag kannst du jederzeit in deinem Kundenkonto einsehen.\n\n" +
      "Zusätzlich informieren wir dich bei jeder Bestellung sowie auf unserer Website transparent darüber, welche Projekte unterstützt werden."
  }
];

CatQuiz.labels = CatQuiz.labels || {};

CatQuiz.labels.DONATION_COPY = {
  strassenkatzen: "Du unterstützt Straßenkatzen in Not – mit jeder Bestellung hilfst du direkt mit.",
  tierheime:      "Du unterstützt Tierheime, die Katzen aufnehmen und versorgen – danke, dass du mithilfst.",
  wildkatzen:     "Du unterstützt den Schutz von Wildkatzen und ihren Lebensräumen – jede Mahlzeit zählt.",
  all:            "Du unterstützt Straßenkatzen, Tierheime und Wildkatzen – gemeinsam helfen wir dort, wo es am nötigsten ist."
};